import React from 'react'
import styles from './globe.module.css'
import { Col, Row } from 'react-bootstrap'
import ca from "../../../public/assets/ca.png"
import de from "../../../public/assets/de.png"
import Lottie from 'react-lottie'
import { lottieOptions } from '../../../utils'
import globe from "../globe.json"

function GlobeSection() {
  return (
    <Row className={styles.globeDiv}>
        <Col lg={7} md={12} sm={12} xs={12} className={styles.globeCol1}>
            <p className={styles.globeHeading}>Send Money to</p>
            <p className={styles.globeHeading2}>18+ Countries</p>
            <p className={styles.globeSubheading}>GIC <img src={ca} alt="" className={styles.image}></img> & Blocked Account <img src={de} className={styles.image} alt=""></img> payments, made easy</p>
        </Col>
        <Col lg={5} md={12} sm={12} xs={12} className={styles.globeCol2}>
        <div className={styles.LottieShadow}>
        <Lottie
              options={lottieOptions(globe)}
            />
            </div>
        </Col>
    </Row>
  )
}

export default GlobeSection